import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { OneNoteProgId, SharePointFolderContentTypeIds } from "../../../src/taskpane/config/constants";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { InfoPanelMode } from "../../Panels/CMFileInfoPanel";
import { CheckinCheckoutHelper } from "../../../utilities/CheckinCheckoutHelper";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { DocumentLandscapeSplitHint20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/DocumentLandscapeSplitHint20Regular";
import { ComponentTypes } from "../../../src/taskpane/config/config";

export function useMenuItem_Replace(selectedItems: any[], waitFor: boolean, setIsCMFileInfoPanelOpen: (isCMFileInfoPanelOpen: boolean) => void, setInfoPanelMode: (infoPanelMode: InfoPanelMode) => void) {
    const languageStrings = React.useContext(LanguageContext);

    const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);
    const isBusySaving = useSelector((state: RootState) => state.savingInBackground.isBusySaving);
    const userAccount = useSelector((state: RootState) => state.user.account);

    const onReplaceClick = React.useCallback(() => {
        setInfoPanelMode(InfoPanelMode.Replace);
        setIsCMFileInfoPanelOpen(true);
    }, [setInfoPanelMode, setIsCMFileInfoPanelOpen]);

    const menuItem_Replace = React.useMemo(() => {
        const hasSingleSelection = selectedItems?.length === 1 && currentDirectory?.type !== ComponentTypes.SharePointList;
        if (!hasSingleSelection) {
            return null;
        }

        const selectedItem = selectedItems[0];

        const isCheckedOutByUser = Array.isArray(selectedItem.CheckoutUser) &&
            selectedItem.CheckoutUser.length > 0 &&
            CheckinCheckoutHelper.compareCurrentUser(selectedItem.CheckoutUser[0], userAccount.username);

        const isNotCheckedOut = !selectedItem.CheckoutUser;

        const canReplaceFile = (isCheckedOutByUser || isNotCheckedOut);

        const hasDeletePermissions = selectedItem.EffectiveBasePermissions?.canDeleteListItem;

        const isNotFolderOrOneNote = !selectedItem.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder) &&
            selectedItem.ProgId !== OneNoteProgId;

        if (canReplaceFile && hasDeletePermissions && isNotFolderOrOneNote) {
            return {
                key: "replace",
                disabled: waitFor || isBusySaving,
                text: languageStrings.ReplaceOnly,
                // iconProps: { iconName: "PostUpdate" },
                iconProps: {},
                onRenderIcon: () => <DocumentLandscapeSplitHint20Regular className={menuItemIconStyles} />,
                onClick: onReplaceClick,
            } as IContextualMenuItem;
        }

        return null;
    }, [selectedItems, waitFor, currentDirectory, userAccount, isBusySaving, languageStrings, onReplaceClick]);

    return {
        menuItem_Replace
    }
}
